const status = {
  CREATED: 'CRIADA',
  VALIDATING: 'VALIDANDO',
  RECEIVED: 'RECEBIDO',
  SCHEDULED: 'AGENDADO',
  TRANSFERRED: 'TRANSFERIDO',
  REMOVED: 'REMOVIDO',
  FAILED: 'FALHA',
  FAILED_INTERNAL: 'FALHA_INTERNA',
  RETURNED: 'DEVOLVIDO',
  FINISHED: 'FINALIZADO',
  EM_REMESSA: 'EM_REMESSA',
  EXECUTING: 'EXECUTANDO',
  BEING_RETURNED: 'EM_DEVOLUCAO',
  REQUESTED_REFUND: 'REEMBOLSO_SOLICITADO'
};

module.exports = status;
